/**
 * NodeLeftIcon
 * Renders the left-side icon of a node header.
 * Priority: Feather icon (by name) → NodeCategoryIcon (category-based default).
 */

import React from 'react';
import { renderFiIcon, NodeCategoryIcon } from '@bizfirst/common-react';

interface NodeLeftIconProps {
  /** Feather icon name e.g. "FiMessageSquare". Falls back to category default when absent. */
  icon?: string;
  /** Category string used by NodeCategoryIcon when icon is not supplied. */
  category?: string;
  size?: number;
  color?: string;
}

export const NodeLeftIcon: React.FC<NodeLeftIconProps> = ({
  icon,
  category = '',
  size = 16,
  color = 'currentColor',
}) => {
  if (icon) {
    const rendered = renderFiIcon(icon, size, color);
    if (rendered) return <>{rendered}</>;
  }
  return <NodeCategoryIcon category={category} size={size} color={color} />;
};
